import 'masonry-layout/dist/masonry.pkgd';
import 'imagesloaded';

$(document).ready(function() {
  // VIDEO
	let video = document.querySelectorAll( ".cms-video-player" );	
	for (let i = 0; i < video.length; i++) {
		let source =  video[i].dataset.image; 
		let image = new Image();
		image.src = source;
		image.addEventListener( "load", function() {
			video[i].appendChild( image );
		}( i ) );
		
		video[i].addEventListener( "click", function() {
			let iframe = document.createElement( "iframe" );
	        iframe.setAttribute( "frameborder", "0" );
	        iframe.setAttribute( "allowfullscreen", "" );
	        iframe.setAttribute( "src", this.dataset.iframe );
	
	        this.innerHTML = "";
	        this.appendChild( iframe );
		});
  }
  
  // MASONRY
  let $grid = $('.cms-responsive-row').masonry({ itemSelector: ".grid-item", columnWidth: ".grid-sizer" });
  $grid.imagesLoaded().progress( function() {
    $grid.masonry('layout');
  });
});
